// prettier-ignore
const initialState = {
  aspects: {
    green:            { section: 'who',   title: 'Mr. Green',       note: '' },
    mustard:          { section: 'who',   title: 'Colonel Mustard', note: '' },
    orchid:           { section: 'who',   title: 'Dr. Orchid',      note: '' },
    peacock:          { section: 'who',   title: 'Mrs. Peacock',    note: '' },
    plum:             { section: 'who',   title: 'Prof. Plum',      note: '' },
    scarlett:         { section: 'who',   title: 'Miss. Scarlett',  note: '' },

    candlestick:      { section: 'what',  title: 'candlestick',     note: '' },
    dagger:           { section: 'what',  title: 'dagger',          note: '' },
    pipe:             { section: 'what',  title: 'pipe',            note: '' },
    revolver:         { section: 'what',  title: 'revolver',        note: '' },
    rope:             { section: 'what',  title: 'rope',            note: '' },
    wrench:           { section: 'what',  title: 'wrench',          note: '' },

    ballroom:         { section: 'where', title: 'ballroom',        note: '' },
    'billiard-room':  { section: 'where', title: 'billiard room',   note: '' },
    conservatory:     { section: 'where', title: 'conservatory',    note: '' },
    'dining-room':    { section: 'where', title: 'dining room',     note: '' },
    hall:             { section: 'where', title: 'hall',            note: '' },
    kitchen:          { section: 'where', title: 'kitchen',         note: '' },
    library:          { section: 'where', title: 'library',         note: '' },
    lounge:           { section: 'where', title: 'lounge',          note: '' },
    study:            { section: 'where', title: 'study',           note: '' },
  },
  useTitles: false,
}

// getters
const getters = {
  sectionAspects: (state) => (section) =>
    Object.entries(state.aspects)
      .filter(([, aspectDetails]) => aspectDetails.section === section)
      .map(([id]) => id),
};

// actions
const actions = {
  initialize({ commit }) {
    commit('INITIALIZE');
  },

  cycleNote({ commit }, aspect) {
    commit('CYCLE_NOTE', aspect);
  },

  resetNotes({ commit }) {
    commit('RESET_NOTES');
  },
};

const mutations = {
  INITIALIZE: () => initialState,

  CYCLE_NOTE(state, aspect) {
    const notes = ['', 'no', 'maybe', 'yes'];
    const oldNote = state.aspects[aspect].note;
    const newNote = notes[(notes.indexOf(oldNote) + 1) % notes.length];
    state.aspects[aspect].note = newNote;
  },

  RESET_NOTES(state) {
    const newNote = { note: '' };
    state.aspects = Object.fromEntries(
      Object.entries(state.aspects).map(([aspect, aspectDetails]) => [
        aspect,
        Object.assign(aspectDetails, newNote),
      ])
    );
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
